import React from 'react';
import {NavLink} from 'react-router-dom';

const TitleAdmin = (props) => {

  return (
    <div className={`TitleAdmin ${props.className}`}>
      <h2>{props.title}</h2>
      <ul className="wrap-adminLnb">
        {props.lnb ? props.lnb.map((el, index) => {
          return <li key={index}><NavLink activeClassName="active" to ={el.path}>{el.name}</NavLink></li>
        }) : ""}
      </ul>
    </div>
  );
}

export default TitleAdmin;